import "./App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Nav from "./components/Nav/Nav";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import About from "./components/About/About";
import Intro from "./components/Intro/Intro";
import Skill from "./components/Skill/Skill";
import Project from "./components/Project/Project";
import Blog from "./components/Blog/Blog";
import NoMatch from "./components/NoMatch/NoMatch";

function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/">
            <Nav />
            <main>
              <Intro />
              <About />
              <Skill />
              <Project />
              <Contact />
            </main>
            <Footer />
          </Route>
          <Route exact path="/about">
            <Nav />
            <main>
              <Intro />
              <About />
            </main>
          </Route>
          <Route exact path="/skill">
            <Nav />
            <main>
              <Skill />
            </main>
          </Route>
          <Route exact path="/project">
            <Nav />
            <main>
              <Project />
            </main>
          </Route>
          <Route exact path="/contact">
            <Nav />
            <main>
              <Contact />
            </main>
            <Footer />
          </Route>
          {/* <Route exact path="/blog">
            <Nav />
            <main>
              <Blog />
            </main>
          </Route> */}
          <Route path="*">
            <NoMatch />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
